import { useCallback, useEffect } from 'react';

const useInfinityScroll = (
  containerRefElement?: any,
  onInfinityScroll: Function = () => {},
  isLoading: boolean = false,
  dataLength: number = 0,
  dataTotalCount: number = 0,
) => {

  const fetchMoreOnBottomReached = useCallback(
    (containerRefElement?: HTMLDivElement | null) => {
      if (containerRefElement) {
        const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
        if (
          scrollHeight - scrollTop - clientHeight < 100 &&
          dataLength < dataTotalCount &&
          !isLoading
        ) {
          onInfinityScroll();
        }
      }
    },
    [onInfinityScroll, isLoading, dataLength, dataTotalCount]
  );

  useEffect(() => {
    if (containerRefElement?.current) fetchMoreOnBottomReached(containerRefElement.current);
  }, [fetchMoreOnBottomReached]);

  return {
    fetchMoreOnBottomReached,
  };
};

export default useInfinityScroll;